import { getEnvValue, parseEnvJson } from "./utils";

function urlValidator(value: string | undefined): boolean | string {
  if (!value) return "Required";
  try {
    new URL(value);
    return true;
  } catch {
    return "Invalid URL";
  }
}

const rpcUrls = (() => {
  const envValue = getEnvValue("NEXT_PUBLIC_NETWORK_RPC_URL");
  const isUrl = urlValidator(envValue);

  if (envValue && isUrl === true) {
    return [envValue];
  }

  const parsedValue = parseEnvJson<Array<string>>(envValue);

  return Array.isArray(parsedValue) ? parsedValue : [];
})();

const chain = Object.freeze({
  id: getEnvValue("NEXT_PUBLIC_NETWORK_ID"),
  name: getEnvValue("NEXT_PUBLIC_NETWORK_NAME"),
  currency: {
    name: getEnvValue("NEXT_PUBLIC_NETWORK_CURRENCY_NAME"),
    weiName: undefined as string | undefined,
    symbol: getEnvValue("NEXT_PUBLIC_NETWORK_CURRENCY_SYMBOL"),
    decimals: Number(getEnvValue("NEXT_PUBLIC_NETWORK_CURRENCY_DECIMALS")),
  },
  rpcUrls,
  isTestnet: getEnvValue("NEXT_PUBLIC_IS_TESTNET") === "true",
});

export default chain;
